import { isObject } from 'src/utils/typeguards/isObject';
import { PopulatedNonPrimitiveValue } from './types';

export const isPopulatedNonPrimitive = (value: unknown): value is PopulatedNonPrimitiveValue => {
    const isPopulatedArray = Array.isArray(value) && !!value.length;
    const isPopulatedObject = isObject(value) && !!Object.keys(value as object).length;
    return isPopulatedArray || isPopulatedObject;
};
